/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("cs", i.count, {});
	if (countPlural == "one") return `${i.count} vybraná možnost`;
	if (countPlural == "other") return `${i.count} vybrané možnosti`;
	return "selected_options";
};

const da_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("da", i.count, {});
	if (countPlural == "one") return `${i.count} valgmulighed valgt`;
	if (countPlural == "other") return `${i.count} valgmuligheder valgt`;
	return "selected_options";
};

const de_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "one") return `${i.count} Option ausgewählt`;
	if (countPlural == "other") return `${i.count} Optionen ausgewählt`;
	return "selected_options";
};

const en_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "one") return `${i.count} selected option`;
	if (countPlural == "other") return `${i.count} selected options`;
	return "selected_options";
};

const es_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "one") return `${i.count} opción seleccionada`;
	if (countPlural == "other") return `${i.count} opciones seleccionadas`;
	return "selected_options";
};

const fr_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "one") return `${i.count} option sélectionnée`;
	if (countPlural == "other") return `${i.count} options sélectionnées`;
	return "selected_options";
};

const hu_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("hu", i.count, {});
	if (countPlural == "one") return `${i.count} lehetőség kiválasztva`;
	if (countPlural == "other") return `${i.count} lehetőség kiválasztva`;
	return "selected_options";
};

const it_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "one") return `${i.count} opzione selezionata`;
	if (countPlural == "other") return `${i.count} opzioni selezionate`;
	return "selected_options";
};

const nl_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("nl", i.count, {});
	if (countPlural == "one") return `${i.count} optie geselecteerd`;
	if (countPlural == "other") return `${i.count} opties geselecteerd`;
	return "selected_options";
};

const pl_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pl", i.count, {});
	if (countPlural == "one") return `${i.count} wybrana opcja`;
	if (countPlural == "other") return `${i.count} wybranych opcji`;
	return "selected_options";
};

const pt_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pt", i.count, {});
	if (countPlural == "one") return `${i.count} opção selecionada`;
	if (countPlural == "other") return `${i.count} opções selecionadas`;
	return "selected_options";
};

const sv_selected_options = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("sv", i.count, {});
	if (countPlural == "one") return `${i.count} val valt`;
	if (countPlural == "other") return `${i.count} val valda`;
	return "selected_options";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const selected_options = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.selected_options(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("selected_options", locale)
	if (locale === "cs") return cs_selected_options(inputs)
	if (locale === "da") return da_selected_options(inputs)
	if (locale === "de") return de_selected_options(inputs)
	if (locale === "en") return en_selected_options(inputs)
	if (locale === "es") return es_selected_options(inputs)
	if (locale === "fr") return fr_selected_options(inputs)
	if (locale === "hu") return hu_selected_options(inputs)
	if (locale === "it") return it_selected_options(inputs)
	if (locale === "nl") return nl_selected_options(inputs)
	if (locale === "pl") return pl_selected_options(inputs)
	if (locale === "pt") return pt_selected_options(inputs)
	return sv_selected_options(inputs)
};